import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[Team SetFilter] Action',
  ResetFilter: '[Team ResetFilter] Action',
}

const initialTeamState: ITeamState = {
  filter: {
    active: true,
  },
}

export interface ITeamState {
  filter?: {
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-Team', whitelist: ['filter']},
  (state: ITeamState = initialTeamState, action: ActionWithPayload<ITeamState>) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialTeamState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
